import React from 'react'
import './loader.scss'

interface WaveDotsLoaderProps {
  dotCount?: number
  duration?: number // in seconds
  style?: React.CSSProperties
}

const WaveDotsLoader: React.FC<WaveDotsLoaderProps> = ({
  dotCount = 5,
  duration = 2,
  style
}) => {
  const dots = Array.from({ length: dotCount })

  const singleStepDuration = duration / (dotCount * 2) // forward + backward

  return (
    <div className="wave-loader" style={style}>
      {dots.map((_, index) => (
        <div
          key={index}
          className="wave-dot"
          style={{
            animationDuration: `${duration}s`,
            animationDelay: `${singleStepDuration * index}s`,
            animationTimingFunction: "steps(1, end)",
            "--step-count": dotCount,
            "--step-index": index,
            "--step-duration": `${singleStepDuration}s`,
          } as React.CSSProperties}
        />
      ))}
    </div>
  );
};

export default WaveDotsLoader